<template>
  <div>
    <a-affix :offsetTop="this.$store.getters.shutdownTriggered ? 103 : 50">
      <a-card class="breadcrumb-card" style="z-index: 10">
        <a-row>
          <a-col :span="device === 'mobile' ? 24 : 12" style="padding-left: 12px; margin-top: 10px">
            <breadcrumb :resource="resource">
              <template #end>
                
              </template>
            </breadcrumb>
          </a-col>
          
          <a-col
          :span="device === 'mobile' ? 24 : 12"
          :style="device === 'mobile' ? { float: 'right', 'margin-top': '12px', 'margin-bottom': '-6px', display: 'table' } : { float: 'right', display: 'table', 'margin-top': '6px' }" >
          
        </a-col>
      </a-row>
    </a-card>
  </a-affix>
  <a-row>
    <a-col :span="24" class="block-justify">
      <h1 class="onboard-title"> {{ $t('label.pricing')}} </h1>
      <p> {{ $t('label.pricing.intro') }} </p>
    </a-col>
    <a-col :md="24" :lg="16">
      <a-card class="bordered-card">
        <a-row>
          
          <a-col :span="24" class="block-justify">
            <h3 class="onboard-subtitle"><cloudServer-outlined /> {{ $t('label.preconfigured.instances') }} </h3>
            <p> {{ $t('label.pricing.preconfigured.description') }}</p>
            <a-table
            class="table"
            size="small"
            :columns="columns"
            :dataSource="data"
            :pagination="false"
            >
            <template #ram="{ record }">
              {{ record.ram }} GB
            </template>
            <template #pvpmonth="{ record }">
              <span>
                <a-tag :color="'geekblue'"   >
                  {{ record.pvpmonth }} &euro;
                </a-tag>
              </span>
            </template>
            <template #pvphour="{ record }">
              <span>
                <a-tag :color="'green'"   >
                  {{ record.pvphour }} &euro;
                </a-tag>
              </span>
            </template>
          </a-table>
          <p style="color:#bb0000;"> {{  $t('label.pricing.storage') }} </p>
        </a-col>
      </a-row>
    </a-card>
  </a-col>
  <a-col :md="24" :lg="8">
    <a-card class="bordered-card">
      <a-row :gutter="[12,12]">
        
        <a-col :span="24" class="block-justify">
          <h3 class="onboard-subtitle"><cloudServer-outlined /> {{ $t('label.custom.instances') }} </h3>
        </a-col>
        
        <a-col :span="24" class="block-justify" style="padding-bottom: 15px;">
          <p> {{ $t('label.pricing.custom.description') }} 
            
          </p>
        </a-col>
        <a-col :span="24" >
          <div class="ant-table ant-table-small">
            <div class="ant-table-container">
              <div class="ant-table-content">
                <div style="text-align:right;">
                  <a @click="resetValues()" style="color:#bb0000;"><UndoOutlined/>{{ $t('label.reset') }}</a>
                </div>
                <table style="table-layout: auto;">
                  <thead class="ant-table-thead">
                    <tr >
                      <th class="ant-table-cell ant-table-column-has-sorters" style="text-align:center;">Component</th>
                      <th class="ant-table-cell ant-table-column-has-sorters" style="text-align:center;">Quantity</th>
                    </tr>
                  </thead>
                  <tbody class="ant-table-tbody">
                    <tr class="ant-table-row ant-table-row-level-0">
                      <td class="ant-table-cell">
                        {{ $t('label.cpu') }}
                      </td>
                      <td class="ant-table-cell">          
                        <a-input-number style="width:100%;" v-focus="true" v-model:value="calculator.vcpu" :placeholder="'Number of cores'" addon-after="Cores"/>
                      </td>
                    </tr>
                    <tr class="ant-table-row ant-table-row-level-0">
                      <td class="ant-table-cell">{{ $t('label.ram') }}</td>
                      <td class="ant-table-cell">  <a-input-number  style="width:100%;" v-model:value="calculator.ram" :placeholder="'Amount of memory'" addon-after="GB"/>
                      </td>
                    </tr>
                    <tr class="ant-table-row ant-table-row-level-0">
                      <td class="ant-table-cell"> {{ $t('label.nvme') }}</td>
                      <td class="ant-table-cell">  <a-input-number style="width:100%;"  v-model:value="calculator.nvme" :placeholder="'Amount of NVMe storage space'" addon-after="GB"/>
                      </td>
                    </tr>
                    <tr class="ant-table-row ant-table-row-level-0">
                      <td class="ant-table-cell">{{ $t('label.ssd') }}</td>
                      <td class="ant-table-cell">  <a-input-number  style="width:100%;" v-model:value="calculator.ssd" :placeholder="'Amount of SSD storage space'" addon-after="GB"/>
                      </td>
                    </tr>
                    <tr class="ant-table-row ant-table-row-level-0">
                      <td class="ant-table-cell">{{ $t('label.hdd') }}</td>
                      <td class="ant-table-cell">  <a-input-number style="width:100%;"  v-model:value="calculator.hdd" :placeholder="'Amount of HDD storage space'" addon-after="GB"/>
                      </td>
                    </tr>
                    <tr class="ant-table-row ant-table-row-level-0">
                      <td class="ant-table-cell">{{ $t('label.backup') }}</td>
                      <td class="ant-table-cell">  <a-input-number style="width:100%;"  v-model:value="calculator.backup" :placeholder="'Amount of backup storage space'" addon-after="GB"/>
                      </td>
                    </tr>
                    <tr class="ant-table-row ant-table-row-level-0">
                      <td class="ant-table-cell">{{ $t('label.ram') }}</td>
                      <td class="ant-table-cell">  <a-input-number  style="width:100%;" v-model:value="calculator.ram" :placeholder="'Amount of memory'" addon-after="GB"/>
                      </td>
                    </tr>
                    <tr class="ant-table-row ant-table-row-level-0">
                      <td class="ant-table-cell">{{ $t('label.buckets') }}</td>
                      <td class="ant-table-cell">  <a-input-number  style="width:100%;" v-model:value="calculator.buckets" :placeholder="'Amount of space used for S3 storage'" addon-after="GB"/>
                      </td>
                    </tr>
                    <tr class="ant-table-row ant-table-row-level-0">
                      <td class="ant-table-cell">{{ $t('label.xfer') }}</td>
                      <td class="ant-table-cell">  <a-input-number :min="100" :step="100" style="width:100%;" v-model:value="calculator.xferinput" :placeholder="'Network transfer'" addon-after="GB"/>
                      </td>
                    </tr>
                    <tr class="ant-table-row ant-table-row-level-0">
                      <td class="ant-table-cell">{{ $t('label.ipv4') }}</td>
                      <td class="ant-table-cell">  <a-input-number  style="width:100%;" v-model:value="calculator.ipv4" :placeholder="'Number of public IP addresses'" addon-after="IP"/>
                      </td>
                    </tr>             
                    <tr class="ant-table-row ant-table-row-level-0">
                      <td class="ant-table-cell">{{ $t('label.loadbal') }}</td>
                      <td class="ant-table-cell">  <a-input-number  style="width:100%;" v-model:value="calculator.loadbal" :placeholder="'Number of load balancers'" addon-after="LB"/>
                      </td>
                    </tr>
                    <tr class="ant-table-row ant-table-row-level-0">
                      <td class="ant-table-cell">{{ $t('label.k8s') }}</td>
                      <td class="ant-table-cell">  <a-input-number  style="width:100%;" v-model:value="calculator.k8s" :placeholder="'Kubernetes clusters'" addon-after="K8s"/>
                      </td>
                    </tr>
                    
                  </tbody>
                  <tfoot class="ant-table-tbody">
                    <tr class="ant-table-row ant-table-row-level-0">
                      <td class="ant-table-cell"> <strong> {{ $t('label.total') }} ({{ $t('label.month') }})</strong></td>
                      <td class="ant-table-cell" style="text-align:right;"><h3>{{ calculator_total }} &euro;</h3></td>
                    </tr>
                    <tr class="ant-table-row ant-table-row-level-0">
                      <td class="ant-table-cell"> <strong> {{ $t('label.total') }} ({{ $t('label.hourly') }})</strong></td>
                      <td class="ant-table-cell" style="text-align:right;"><h3>{{ calculator_total_hour }} &euro;</h3></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </a-col>
        
      </a-row>
    </a-card>
  </a-col>
</a-row>

</div>
</template>

<script>
import { mixinDevice } from '@/utils/mixin.js'
import { getPricing,getCustomPricingMonth,getCustomPricingHour } from '@/utils/util'

import Breadcrumb from '@/components/widgets/Breadcrumb'

export default {
  name: 'LinubeOffering',
  components: {
    Breadcrumb,
    
  },
  mixins: [mixinDevice],
  watch: {
    calculator: {
      handler(n,o) {
        this.calculator.xfer = Math.round(n.xferinput / 100) * 100;
        if (this.calculator.xfer < 100) {
          this.calculator.xfer = 100
          this.calculator.xferinput = 100
        } else {
          this.calculator.xferinput = this.calculator.xfer
        }
        this.calculator_total = getCustomPricingMonth(this.calculator.vcpu, 
        this.calculator.ram, 
        this.calculator.nvme, 
        this.calculator.ssd, 
        this.calculator.hdd, 
        this.calculator.backup,
        this.calculator.buckets, 
        this.calculator.xfer, 
        this.calculator.ipv4,
        this.calculator.loadbal, 
        this.calculator.k8s)
        this.calculator_total_hour = getCustomPricingHour(this.calculator.vcpu, 
        this.calculator.ram, 
        this.calculator.nvme, 
        this.calculator.ssd, 
        this.calculator.hdd, 
        this.calculator.backup,
        this.calculator.buckets, 
        this.calculator.xfer, 
        this.calculator.ipv4,
        this.calculator.loadbal, 
        this.calculator.k8s)
      },
      deep: true,
    }
  },
  data () {
    return {
      loading: false,
      resource: {},
      columns: [
      {
        title: this.$t('label.pricing.name'),
        dataIndex: 'name',
        key: 'name',
        sorter: (a, b) => a.name.length - b.name.length,
      },
      {
        title: 'vCPU',
        dataIndex: 'vcpu',
        key: 'vcpu',
        sorter: (a,b) => a.vcpu - b.vcpu,
        onFilter: (value, record) => record.vcpu == value,
        filters: [
        { text: '1', value: 1 },
        { text: '2', value: 2 },
        { text: '4', value: 4 },
        { text: '8', value: 8 },
        { text: '16', value: 16 },
        { text: '32', value: 32 },
        { text: '48', value: 48 },
        { text: '64', value: 64 },
        ],
        filterMultiple: true,
      },
      {
        title: this.$t('label.pricing.ram'),
        dataIndex: 'ram',
        key: 'ram',
        slots: { customRender: 'ram' },
        sorter: (a,b) => a.ram - b.ram,
        onFilter: (value, record) => record.ram == value,
        filters: [
        { text: '2', value: 2 },
        { text: '4', value: 4 },
        { text: '8', value: 8 },
        { text: '16', value: 16 },
        { text: '32', value: 32 },
        { text: '64', value: 64 },
        { text: '96', value: 96 },
        { text: '128', value: 128 },
        { text: '192', value: 192 },
        { text: '256', value: 256 },
        ],
        filterMultiple: true,
      },
      {
        title: this.$t('label.pricing.pvpmonth'),
        dataIndex: 'pvpmonth',
        key: 'pvpmonth',
        slots: { customRender: 'pvpmonth' },
        sorter: (a,b) => a.pvpmonth - b.pvpmonth
      },
      {
        title: this.$t('label.pricing.pvphour'),
        dataIndex: 'pvphour',
        key: 'pvphour',
        slots: { customRender: 'pvphour' },
        sorter: (a,b) => a.pvphour - b.pvphour
      },
      ],
      data: getPricing(),
      calculator: {
        vcpu: 0, 
        ram: 0, 
        nvme: 0, 
        ssd: 0, 
        hdd: 0, 
        backup: 0,
        buckets: 0, 
        xfer: 0,
        xferinput:0,
        ipv4: 0,
        loadbal: 0, 
        k8s: 0,
      },
      calculator_total: 0,
      calculator_total_hour: 0,
    }
  },
  methods: {
    resetValues() {
      this.calculator = {
        vcpu: 0, 
        ram: 0, 
        nvme: 0, 
        ssd: 0, 
        hdd: 0, 
        backup: 0,
        buckets: 0, 
        xfer: 0,
        xferinput:0,
        ipv4: 0,
        loadbal: 0, 
        k8s: 0,
      }
    }
  }
}
</script>

<style scoped>
.breadcrumb-card {
  margin-left: -24px;
  margin-right: -24px;
  margin-top: -16px;
  margin-bottom: 12px;
}

.row-element {
  margin-bottom: 10px;
}

.ant-breadcrumb {
  vertical-align: text-bottom;
}

:deep(.ant-switch-inner) {
  display: block;
  font-size: 14px;
  margin: 0px 14px 0px 28px;
}

:deep(.ant-alert-message) {
  display: flex;
  align-items: center;
}

.hide {
  display: none !important;
}
</style>
